import React from 'react'
import { useNavigate } from 'react-router-dom'

const SingleProductTab = ({data}) => {
  const navigate=useNavigate();
  return (
    <a onClick={()=>{navigate(`./product/${data._id}`)}} className="group">
      <div
        className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
        <img src={data.images[0]}
            alt="Tall slender porcelain bottle with natural clay textured body and cork stopper."
            className="h-full w-full object-cover object-center group-hover:opacity-75"/>
      </div>
      <h3 className="mt-4 text-sm text-gray-700">{data.name}</h3>
      <p className="mt-1 text-lg font-medium text-gray-900">Rs {data.price}</p>
    </a>
  )
}

export default SingleProductTab